module.exports = __webpack_public_path__ + "img/welcome-to-ledger-city.db09ec15.png";